import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorAdd from "../../../util/ErrorAdd";

function ModalCompleteCancel({ show, onHide, onHideTask, name, idTask, idUser }) {

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    //ОТКРЫТИЕ/ЗАКРЫТИЕ МОДАЛЬНОЕ ОКНО
    useEffect(() => {
        //открытие
        if (show === true) {
            setLog(null);
            setLoading(false);
        }
    }, [show]);

    function handler() {

        axios.post('/api_tracker/task/statusCompleteCancel', { ID_Task: idTask, ID_User: idUser })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoading(false);
                    onHide();
                    onHideTask();
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            <Modal show={show} onHide={onHide} >
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-20">Отмена завершения задачи</div>
                    <div className="text-center mb-3">Подтвердите отмену завершения задачи
                        <br></br>
                        <b>«{name}»</b>
                    </div>
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    <div className="row mt-15">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="cancel" loading={loading} size={'lg'} onClick={() => handler()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default ModalCompleteCancel;
